export function getStoredEatsAppUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
}

export function getEatsAppRole(user = getStoredEatsAppUser()) {
  return String(user?.userRole || user?.role || '').toUpperCase();
}

export function isEatsAppUser(user = getStoredEatsAppUser()) {
  return String(user?.domain || '').toUpperCase() === 'EATS_APP';
}

export function isEatsAppRootAdmin(user = getStoredEatsAppUser()) {
  if (!isEatsAppUser(user)) return false;
  return getEatsAppRole(user) === 'ROOT_ADMIN';
}

/** APP_USER / APP_ADMIN / ROOT_ADMIN — can use dashboard onboarding flows. */
export function isEatsAppManager(user = getStoredEatsAppUser()) {
  if (!isEatsAppUser(user)) return false;
  const role = getEatsAppRole(user);
  return role === 'ROOT_ADMIN' || role === 'APP_ADMIN' || role === 'APP_USER';
}

/** Only root admins manage other Eats Business employees. */
export function canManageEatsEmployees(user = getStoredEatsAppUser()) {
  return isEatsAppRootAdmin(user);
}

export function canManageRestaurantServices(user = getStoredEatsAppUser()) {
  return isEatsAppManager(user);
}
